import { FormikProps } from "formik"
import React, { useRef } from "react"

import { useNavigate } from "react-router"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../../core/api/errorTypes"
import { CreateOrEditProductNumber } from "../productNumbersTypes"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { CreateUpdateProductGroupNumberForm } from "../components/CreateUpdateProductGroupNumberForm"
import { SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE, SUPPLIER_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { createProductNumberApi, ProductNumbersQuery } from "../productNumbersApi"
import { useCurrentSupplier } from "../../../../../suppliers/supplierHooks"

export function CreateProductNumber() {
    const navigate = useNavigate()
    const formRef = useRef<FormikProps<CreateOrEditProductNumber>>(null)
    const { supplierId } = useCurrentSupplier()

    const handleSaveClick = () => {
        formRef.current?.submitForm()
    }

    const { mutate: callCreateProductGroupNumber } = useApiMutation(createProductNumberApi, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({ queryKey: [ProductNumbersQuery.LIST] })
            navigate(SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE)
        },
    })

    const createProductGroupNumber = (data: CreateOrEditProductNumber) => {
        callCreateProductGroupNumber({
            supplier: {
                id: supplierId,
            },
            ...data,
        })
    }

    return (
        <>
            <LocalizedStrict id="supplier-admin-erp-product-group-numbers-create-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPLIER_PRODUCTS_GROUPS_NUMBERS_CREATE}
                    title="Create product number"
                    rightElement={
                        <LocalizedStrict id="supplier-admin-erp-product-group-numbers-create-button">
                            <StandardButton onClick={handleSaveClick}>Create</StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="supplier-nav-item-home">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-erp">
                            <Breadcrumb>ERP</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-product-numbers">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE}>Product numbers</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-create-product-group-number">
                            <Breadcrumb>Create product number</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateProductGroupNumberForm ref={formRef} onSubmit={createProductGroupNumber} />
        </>
    )
}
